import { ReactNode } from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { APP_LK_STAGE, APP_LOCAL_SCHEME, EStages } from './app';

import { DashboardPage, CatalogPage, ModulePage, SickListPage } from ':pages';
import type { PageRouterItem, TransformHardCode } from ':types';

// TODO: temporary solution for backward compatibility
const SicklistsRedirect = (): ReactNode => {
  const { employeeNumber } = useParams();
  return <Navigate to={`/sicklists/employee/${employeeNumber}`} />;
};

// TODO: temporary solution for backward compatibility
const ColleagueProfileRedirect = (): ReactNode => {
  const { employeeNumber } = useParams();
  return <Navigate to={`/colleague/${employeeNumber}`} replace />;
};

const pages: PageRouterItem[] = [
  {
    element: <DashboardPage />,
    path: '/',
    enabled: true,
  },
  {
    element: <ColleagueProfileRedirect />,
    path: 'employees/:employeeNumber',
    enabled: true,
  },
  {
    element: <CatalogPage />,
    path: 'catalog/*',
    enabled: true,
  },
  // TODO: Backward compatibility: legacy path
  {
    element: <SicklistsRedirect />,
    path: 'employees/:employeeNumber/sicklists',
    enabled: true,
  },
  // TODO: remove this page, temporary solution
  {
    element: <SickListPage />,
    path: 'sicklists/employee/:employeeNumber',
    enabled: true,
  },
  // TODO: end
  {
    element: <ModulePage />,
    path: '*',
    enabled: true,
  },
];

export const enabledPage = pages.filter(({ enabled }) => enabled);

const nonProduction = [EStages.production].includes(APP_LK_STAGE)
  ? []
  : [...(APP_LOCAL_SCHEME?.pages ?? [])];

export const HARD_CODE_PATHS: TransformHardCode = {
  ...nonProduction.reduce((prev, { component_id, host_url, url, route }) => {
    return {
      [url || route]: {
        component_id,
        host_url,
      },
      ...prev,
    };
  }, {}),
};
